{
    angular.module('interfaceModule')
        .controller('PrintSettingsController',PrintSettingsController);
    PrintSettingsController.$inject = ['$state',"$stateParams",'utils.constant',"request.order",
    "request.file",'utils.common','utils.currentUser','$scope',
    'utils.global','requestHandler'];
    function PrintSettingsController($state,$stateParams,constant,orderRequest,
    	fileRequest,common,currentUser,$scope,
    global,requestHandler) {
        let vm=this;
        let collect={
            'activate':activate,
            'reupload':reupload,
            'fileData':null,
            'formData':{},
            'numberCheck':numberCheck,
            'pageNumLimitCheck':pageNumLimitCheck,

            'printType':$stateParams.printType==1?1:0,
            'docInfo':null,
            'printInfo':null,
            'orderInfo':null,

            'printSizeList':{},
            'price':0,
            'paperNum':0,
            'amount':0,
            'updateAmount':updateAmount,
            'saveSettings':saveSettings,
            'gotoPreview':gotoPreview,

            'canprintagain':$stateParams.canprintagain,
            'isCantChange': false,//是否可修改
            'userId':null,
            'areaid':null,
            'areaname':null,

        };
        vm.collect=collect;
        activate();

        function activate(){
            requestHandler.simpleRequest(constant.action.getUserId).then(function (respone) {

                collect.userId=respone.data[0].loginuserid;
                collect.areaid=respone.data[0].areaid;
                collect.areaname=respone.data[0].areaname;

                if(currentUser.info){
                    init();
                }else{
                    let destructor=$scope.$on('user.logged',function(event,data){
                        console.log('刷新后：',data);
                        init();
                        destructor();
                    });
                }
            })
        }

        function init(){
            console.log('用户id：',collect.userId);
            orderRequest.getPrintSizeSelection(collect.areaid).then(function(data){
                console.log('获取规格：',data);
                collect.printSizeList=data.sizeList;
                if($stateParams.canprintagain){
                    collect.isCantChange =true;
                }
                console.log("是否可修改：",collect.isCantChange);
                if($stateParams.orderId){
                    
                    common.loading.show('正在获取上传的文件信息...');

                    orderRequest.getOrderInfo($stateParams.orderId)
                    .then(function(data){
                        common.loading.hide();
                        console.log(data);
                        collect.docInfo=data.docInfo;
                        collect.printInfo=data.printInfo;
                        collect.orderInfo=data.orderInfo;


                        collect.printType=collect.printInfo.printType=="论文打印"?1:0;
                        collect.fileData={
                            'docId':collect.docInfo.docId,
                            'fileName':collect.docInfo.fileName,
                            'pageNum':collect.docInfo.pageNum,
                            'uploadDate':collect.docInfo.uploadDate,
                            'printType':collect.printType
                        }
                        collect.formData={
                            'format':null,
                            'copiesNum':collect.printInfo.copiesNum,
                            'mode':collect.printType==0?'1':'2',
                            'startPage':1,
                            'endPage':collect.fileData.pageNum,
                            'singleSidedNum':0,
                            'printAllPage':true
                        }
                        
                        if(global.printSettingsData){
                            collect.formData=global.printSettingsData;
                            collect.printSizeList
                            global.printSettingsData=null;
                        }

                        for(let i=0;i<collect.printSizeList.length;i++){
                            if(collect.printSizeList[i].title==collect.printInfo.size_title){
                                collect.formData.format=collect.printSizeList[i];
                            }
                        };
                        setCover(collect.fileData.docId,collect.fileData.pageNum);
                        
                        updateAmount();
                    },function(){
                        common.loading.hide();
                    });
                }else{
                    collect.formData={
                        'format':collect.printSizeList[0],
                        'copiesNum':1,
                        'mode':collect.printType==0?'1':'2',
                        'startPage':1,
                        'endPage':1,
                        'singleSidedNum':0,
                        'printAllPage':true
                    }
                
                    common.loading.show('正在获取上传的文件信息...');
                    fileRequest.getUploadResult().then(function(data){
                        console.log("文件上传后信息：",data);
                        common.loading.hide();
                        if(data.result == 1){
                            collect.fileData=data.fileData;
                            collect.fileData.printType=collect.printType;

                            collect.formData.endPage=collect.fileData.pageNum;

                            if(global.printSettingsData){
                                collect.formData=global.printSettingsData;
                                global.printSettingsData=null;
                                for(let i=0;i<collect.printSizeList.length;i++){
                                    if(collect.printSizeList[i].title==collect.formData.format.title){
                                        collect.formData.format=collect.printSizeList[i];
                                    }
                                };
                            }
                            sessionStorage.setItem('fileData',JSON.stringify(collect.fileData));
                            sessionStorage.setItem('formData',JSON.stringify(collect.formData));
                        }else{
                            var fileData = sessionStorage.getItem('fileData'),
                                formData = sessionStorage.getItem('formData');
                            collect.fileData = JSON.parse(fileData);
                            collect.formData =  JSON.parse(formData);
                            console.log("session1:",collect.fileData);
                            console.log("session2:",collect.formData);
                            if(global.printSettingsData){
                                collect.formData=global.printSettingsData;
                                global.printSettingsData=null;
                            }
                            for(let i=0;i<collect.printSizeList.length;i++){
                                if(collect.printSizeList[i].title==collect.formData.format.title){
                                    collect.formData.format=collect.printSizeList[i];
                                }
                            };
                        }

                        setCover(collect.fileData.docId,collect.fileData.pageNum);
                        updateAmount();

                    },function(){
                        common.loading.hide();
                    });
                }
            });

        }
        //再印一次



        function setCover(docId,pageNum){

            let path=constant.config.sitePath+constant.config.previewPath+"/";

            if (collect.fileData.fileName.toLowerCase().endsWith(".doc") || collect.fileData.fileName.toLowerCase().endsWith(".docx"))
            {
                collect.fileData.coverPath=path+"file_type_word.png";
            }
            else if (collect.fileData.fileName.toLowerCase().endsWith(".ppt") || collect.fileData.fileName.toLowerCase().endsWith(".pptx"))
            {
                collect.fileData.coverPath=path+"file_type_ppt.png";
            }
            else if (collect.fileData.fileName.toLowerCase().endsWith(".pdf"))
            {
                collect.fileData.coverPath=path+"file_type_pdf.png";
            }
            else {
                collect.fileData.coverPath=path+"file_type_image.png";
            }
        }

        //重新上传
        function reupload(){
        	$state.go('main.home');
        }
        //点击去支付按钮（此时进行下单）
        function saveSettings(){
        	//docData,sizeFormat,printType,printMode,copiesNum,singleSidedNum
            if($stateParams.orderId){
                if($stateParams.canprintagain){
                    var orderinfo = new Object();
                    orderinfo.orderid = $stateParams.orderId;
                    orderinfo.userid  = currentUser.info.userId;
                    orderinfo.printsizetitle   = collect.formData.format.title;
                    //orderinfo.printsizewidth   = collect.printInfo.size_width;//0905
                    //orderinfo.printsizeheight   = collect.printInfo.size_height;//0905

                    orderinfo.printsizewidth   = collect.formData.format.width;//0905后
                    orderinfo.printsizeheight   = collect.formData.format.height;//0905后
                    orderinfo.printnums   = collect.formData.copiesNum;
                    orderinfo.printmode   = collect.formData.mode;

                    console.log("传参printmode:",orderinfo.printmode);
                    orderinfo.singlepagenum   = collect.formData.singleSidedNum;
                    orderinfo.docid   = collect.docInfo.docId;
                    //orderinfo.printtype   = collect.printInfo.printType;

                    orderinfo.printtype   = collect.printType;
                    orderinfo.docname   = encodeURIComponent(collect.docInfo.fileName);
                    orderinfo.docpages   = collect.docInfo.pagecount;//

                    if(orderinfo.printmode == 1){
                        orderinfo.discount = collect.formData.format.discount;
                        orderinfo.pricepage = collect.formData.format.pricepage;
                    }else if(orderinfo.printmode==2){
                        orderinfo.pricepage = collect.formData.format.pricepage_d;
                        orderinfo.discount = collect.formData.format.discount_d;
                    }

                    console.log("传参discount:",orderinfo.discount );
                    console.log("传参pricepage:",orderinfo.pricepage );
                    //orderinfo.docprice   = orderinfo.pricepage*orderinfo.docpages;
                    let paperNum=0;
                    if(orderinfo.printtype==0){
                        //paperNum=Math.ceil((collect.fileData.pageNum)/orderinfo.printmode);
                        paperNum=Math.ceil((collect.fileData.pageNum)/orderinfo.printmode);
                    }else{
                        //paperNum=collect.printInfo.singleSidedNum+Math.ceil((collect.fileData.pageNum-collect.printInfo.singleSidedNum)/2);
                        paperNum=collect.formData.singleSidedNum+Math.ceil((collect.fileData.pageNum-collect.formData.singleSidedNum)/2);
                    }

                    console.log("传参paperNum:",paperNum);
                    console.log("传参pricepage:",orderinfo.pricepage);

                    orderinfo.docprice=orderinfo.pricepage*paperNum;
                    console.log("传参docprice:",orderinfo.docprice);
                    orderinfo.discountprice   = orderinfo.docprice*orderinfo.discount/100;
                    orderinfo.pricetotal = orderinfo.discountprice*orderinfo.printnums;
                    let orderinfo_array = new Array();
                    orderinfo_array.push(orderinfo);
                    let params = null;
                    params = "orderinfo=" + JSON.stringify(orderinfo_array);
                    console.log("再印状态传参：",orderinfo_array);
                    /*
                    * log start
                    * */
                    let _logdata = [{
                        "querytype":0,
                        "userid": collect.userId,
                        "logcontent":'再印一次传参：'+params

                    }];
                    let paramslog='debuglog='+JSON.stringify(_logdata);
                    requestHandler.simpleRequest(constant.action.debuglog, paramslog,function (data) {
                        console.log("debug返回：",data);
                    });
                    /*
                    * log end
                    * */
                    requestHandler.simpleRequest(constant.action.ordersnew_printagain,params,function (responce) {
                        console.log("响应返回",responce)
                        if(responce.data[0].result == 1){
                            $state.go('main.pay',{'orderId':responce.data[0].orderid});
                        }else if(responce.data[0].result == 0){
                            common.alert("下单失败，请重新尝试");
                        }
                    })
                }else{
                    orderRequest.modifyOrder(
                        collect.orderInfo.orderId,
                        collect.orderInfo.orderPrintId,
                        collect.fileData,
                        collect.formData.format,
                        collect.printType,
                        collect.formData.mode,
                        collect.formData.copiesNum,
                        collect.formData.singleSidedNum)
                        .then(function(resData){
                            // console.log(resData);
                            $state.go('main.pay',{'orderId':collect.orderInfo.orderId});
                        });
                }
            }else{  //新单下单
                orderRequest.createOrder(
                    collect.fileData,
                    collect.formData.format,
                    collect.printType,
                    collect.formData.mode,
                    collect.formData.copiesNum,
                    collect.formData.singleSidedNum,
                    collect.areaid)
                .then(function(resData){
                    // console.log(resData);
                    $state.go('main.pay',{'orderId':resData.orderId});
                });
            }
        	
        }

        function gotoPreview(){
            global.printSettingsData=collect.formData;
            $state.go('main.preview',{'orderId':$stateParams.orderId,'printType':collect.printType});
        }

        function numberCheck(key){
        	// console.log(parseInt(collect.formData[key]));
        	let num=parseInt(collect.formData[key]);
        	// console.log(isNaN(num))
        	if(isNaN(num)){
        		collect.formData[key]=0;
        	}else{
        		collect.formData[key]=num;
        	}
        }
        function pageNumLimitCheck(key){
        	// console.log(parseInt(collect.formData[key]));
        	let num=parseInt(collect.formData[key]);
        	// console.log(isNaN(num))
        	if(isNaN(num)){
        		collect.formData[key]=0;
        	}else if(num>collect.fileData.pageNum){
        		collect.formData[key]=collect.fileData.pageNum
        	}else{
        		collect.formData[key]=num;
        	}
        }

        function updateAmount(){
        	if(vm.collect.printType==0){
        		collect.paperNum=Math.ceil((collect.fileData.pageNum)/vm.collect.formData.mode);
        	}else{
        		collect.paperNum=parseInt(collect.formData.singleSidedNum)+Math.ceil((collect.fileData.pageNum-collect.formData.singleSidedNum)/2);
        	
        	}
        	// console.log(collect.formData.format.pricepage_d,
         //        collect.paperNum,collect.formData.format.discount_d);
        	let price=0;
        	if(vm.collect.formData.mode==1){
        		price=collect.formData.format.pricepage*collect.formData.format.discount/100;
        	}else if(vm.collect.formData.mode==2){
				price=collect.formData.format.pricepage_d*collect.formData.format.discount_d/100;
        	}
        	collect.amount=price*collect.paperNum*collect.formData.copiesNum;
        }
    }
    
}